import React from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var emoji = {
  people: ['😀', '😬', '😁', '😂', '😃', '😄', '😅', '😆', '😇', '😉', '😊', '🙂', '🙃', '☺️', '😋', '😌', '😍', '😘', '😗', '😙', '😚', '😜', '😝', '😛', '🤑', '🤓', '😎', '🤗', '😏', '😶', '😐', '😑', '😒', '🙄', '🤔', '😳', '😞', '😟', '😠', '😡', '😔', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '😓', '😭', '😵', '😲', '🤐', '😷', '🤒', '🤕', '😴', '💤', '💩', '😈', '👿', '👹', '👺', '💀', '👻', '👽', '🤖', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '🙌', '👏', '👋', '👍', '👊', '✊', '✌️', '👌', '✋', '💪', '🙏', '☝️', '👆', '👇', '👈', '👉', '🖕', '🤘', '🖖', '✍️', '💅', '👄', '👅', '👂', '👃', '👁', '👀', '👤', '🗣', '👶', '👦', '👧', '👨', '👩', '👱', '👴', '👵', '👲', '👳', '👮', '👷', '💂', '🕵', '🎅', '👼', '👸', '👰', '🚶', '🏃', '💃', '👯', '👫', '👬', '👭', '🙇', '💁', '🙅', '🙆', '🙋', '🙎', '🙍', '💇', '💆', '💑', '👩‍❤️‍👩', '👨‍❤️‍👨', '💏', '👩‍❤️‍💋‍👩', '👨‍❤️‍💋‍👨', '👪', '👨‍👩‍👧', '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', '👨‍👩‍👧‍👧', '👩‍👩‍👦', '👩‍👩‍👧', '👩‍👩‍👧‍👦', '👩‍👩‍👦‍👦', '👩‍👩‍👧‍👧', '👨‍👨‍👦', '👨‍👨‍👧', '👨‍👨‍👧‍👦', '👨‍👨‍👦‍👦', '👨‍👨‍👧‍👧', '👚', '👕', '👖', '👔', '👗', '👙', '👘', '💄', '💋', '👣', '👠', '👡', '👢', '👞', '👟', '👒', '🎩', '⛑', '🎓', '👑', '🎒', '👝', '👛', '👜', '💼', '👓', '🕶', '💍', '🌂'],
  nature: ['🐶', '🐱', '🐭', '🐹', '🐰', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐽', '🐸', '🐙', '🐵', '🙈', '🙉', '🙊', '🐒', '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🐌', '🐞', '🐜', '🕷', '🦂', '🦀', '🐍', '🐢', '🐠', '🐟', '🐡', '🐬', '🐳', '🐋', '🐊', '🐆', '🐅', '🐃', '🐂', '🐄', '🐪', '🐫', '🐘', '🐐', '🐏', '🐑', '🐎', '🐖', '🐀', '🐁', '🐓', '🦃', '🕊', '🐕', '🐩', '🐈', '🐇', '🐿', '🐾', '🐉', '🐲', '🌵', '🎄', '🌲', '🌳', '🌴', '🌱', '🌿', '☘', '🍀', '🎍', '🎋', '🍃', '🍂', '🍁', '🌾', '🌺', '🌻', '🌹', '🌷', '🌼', '🌸', '💐', '🍄', '🌰', '🎃', '🐚', '🕸', '🌎', '🌍', '🌏', '🌕', '🌖', '🌗', '🌘', '🌑', '🌒', '🌓', '🌔', '🌚', '🌝', '🌛', '🌜', '🌞', '🌙', '⭐️', '🌟', '💫', '✨', '☄', '☀️', '🌤', '⛅️', '🌥', '🌦', '☁️', '🌧', '⛈', '🌩', '⚡️', '🔥', '💥', '❄️', '🌨', '🔥', '💥', '❄️', '🌨', '☃️', '⛄️', '🌬', '💨', '🌪', '🌫', '☂️', '☔️', '💧', '💦', '🌊'],
  'food-and-drink': ['🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑', '🍍', '🍅', '🍆', '🌶', '🌽', '🍠', '🍯', '🍞', '🧀', '🍗', '🍖', '🍤', '🍳', '🍔', '🍟', '🌭', '🍕', '🍝', '🌮', '🌯', '🍜', '🍲', '🍥', '🍣', '🍱', '🍛', '🍙', '🍚', '🍘', '🍢', '🍡', '🍧', '🍨', '🍦', '🍰', '🎂', '🍮', '🍬', '🍭', '🍫', '🍿', '🍩', '🍪', '🍺', '🍻', '🍷', '🍸', '🍹', '🍾', '🍶', '🍵', '☕️', '🍼', '🍴', '🍽'],
  activity: ['⚽️', '🏀', '🏈', '⚾️', '🎾', '🏐', '🏉', '🎱', '⛳️', '🏌', '🏓', '🏸', '🏒', '🏑', '🏏', '🎿', '⛷', '🏂', '⛸', '🏹', '🎣', '🚣', '🏊', '🏄', '🛀', '⛹', '🏋', '🚴', '🚵', '🏇', '🕴', '🏆', '🎽', '🏅', '🎖', '🎗', '🏵', '🎫', '🎟', '🎭', '🎨', '🎪', '🎤', '🎧', '🎼', '🎹', '🎷', '🎺', '🎸', '🎻', '🎬', '🎮', '👾', '🎯', '🎲', '🎰', '🎳'],
  'travel-and-places': ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🏍', '🚲', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚝', '🚄', '🚅', '🚈', '🚞', '🚂', '🚆', '🚇', '🚊', '🚉', '🚁', '🛩', '✈️', '🛫', '🛬', '⛵️', '🛥', '🚤', '⛴', '🛳', '🚀', '🛰', '💺', '⚓️', '🚧', '⛽️', '🚏', '🚦', '🚥', '🏁', '🚢', '🎡', '🎢', '🎠', '🏗', '🌁', '🗼', '🏭', '⛲️', '🎑', '⛰', '🏔', '🗻', '🌋', '🗾', '🏕', '⛺️', '🏞', '🛣', '🛤', '🌅', '🌄', '🏜', '🏖', '🏝', '🌇', '🌆', '🏙', '🌃', '🌉', '🌌', '🌠', '🎇', '🎆', '🌈', '🏘', '🏰', '🏯', '🏟', '🗽', '🏠', '🏡', '🏚', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🏛', '⛪️', '🕌', '🕍', '🕋', '⛩'],
  objects: ['⌚️', '📱', '📲', '💻', '⌨', '🖥', '🖨', '🖱', '🖲', '🕹', '🗜', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽', '🎞', '📞', '☎️', '📟', '📠', '📺', '📻', '🎙', '🎚', '🎛', '⏱', '⏲', '⏰', '🕰', '⏳', '⌛️', '📡', '🔋', '🔌', '💡', '🔦', '🕯', '🗑', '🛢', '💸', '💵', '💴', '💶', '💷', '💰', '💳', '💎', '⚖', '🔧', '🔨', '⚒', '🛠', '⛏', '🔩', '⚙', '⛓', '🔫', '💣', '🔪', '🗡', '⚔', '🛡', '🚬', '☠', '⚰', '⚱', '🏺', '🔮', '📿', '💈', '⚗', '🔭', '🔬', '🕳', '💊', '💉', '🌡', '🏷', '🔖', '🚽', '🚿', '🛁', '🔑', '🗝', '🛋', '🛌', '🛏', '🚪', '🛎', '🖼', '🗺', '⛱', '🗿', '🛍', '🎈', '🎏', '🎀', '🎁', '🎊', '🎉', '🎎', '🎐', '🎌', '🏮', '✉️', '📩', '📨', '📧', '💌', '📮', '📪', '📫', '📬', '📭', '📦', '📯', '📥', '📤', '📜', '📃', '📑', '📊', '📈', '📉', '📄', '📅', '📆', '🗓', '📇', '🗃', '🗳', '🗄', '📋', '🗒', '📁', '📂', '🗂', '🗞', '📰', '📓', '📕', '📗', '📘', '📙', '📔', '📒', '📚', '📖', '🔗', '📎', '🖇', '✂️', '📐', '📏', '📌', '📍', '🚩', '🏳', '🏴', '🔐', '🔒', '🔓', '🔏', '🖊', '🖊', '🖋', '✒️', '📝', '✏️', '🖍', '🖌', '🔍', '🔎'],
  symbols: ['❤️', '💛', '💙', '💜', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮', '✝️', '☪', '🕉', '☸', '✡️', '🔯', '🕎', '☯️', '☦', '🛐', '⛎', '♈️', '♉️', '♊️', '♋️', '♌️', '♍️', '♎️', '♏️', '♐️', '♑️', '♒️', '♓️', '🆔', '⚛', '🈳', '🈹', '☢', '☣', '📴', '📳', '🈶', '🈚️', '🈸', '🈺', '🈷️', '✴️', '🆚', '🉑', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈲', '🅰️', '🅱️', '🆎', '🆑', '🅾️', '🆘', '⛔️', '📛', '🚫', '❌', '⭕️', '💢', '♨️', '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '❗️', '❕', '❓', '❔', '‼️', '⁉️', '💯', '🔅', '🔆', '🔱', '⚜', '〽️', '⚠️', '🚸', '🔰', '♻️', '🈯️', '💹', '❇️', '✳️', '❎', '✅', '💠', '🌀', '➿', '🌐', 'Ⓜ️', '🏧', '🈂️', '🛂', '🛃', '🛄', '🛅', '♿️', '🚭', '🚾', '🅿️', '🚰', '🚹', '🚺', '🚼', '🚻', '🚮', '🎦', '📶', '🈁', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '🔢', '▶️', '⏸', '⏯', '⏹', '⏺', '⏭', '⏮', '⏩', '⏪', '🔀', '🔁', '🔂', '◀️', '🔼', '🔽', '⏫', '⏬', '➡️', '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '↕️', '↔️', '🔄', '↪️', '↩️', '⤴️', '⤵️', '#️⃣', '*️⃣', 'ℹ️', '🔤', '🔡', '🔠', '🔣', '🎵', '🎶', '〰️', '➰', '✔️', '🔃', '➕', '➖', '➗', '✖️', '💲', '💱', '©️', '®️', '™️', '🔚', '🔙', '🔛', '🔝', '🔜', '☑️', '🔘', '⚪️', '⚫️', '🔴', '🔵', '🔸', '🔹', '🔶', '🔷', '🔺', '▪️', '▫️', '⬛️', '⬜️', '🔻', '◼️', '◻️', '◾️', '◽️', '🔲', '🔳', '🔈', '🔉', '🔊', '🔇', '📣', '📢', '🔔', '🔕', '🃏', '🀄️', '♠️', '♣️', '♥️', '♦️', '🎴', '👁‍🗨', '💭', '🗯', '💬', '🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '🕜', '🕝', '🕞', '🕟', '🕠', '🕡', '🕢', '🕣', '🕤', '🕥', '🕦', '🕧'],
  flags: ['🇦🇫', '🇦🇽', '🇦🇱', '🇩🇿', '🇦🇸', '🇦🇩', '🇦🇴', '🇦🇮', '🇦🇶', '🇦🇬', '🇦🇷', '🇦🇲', '🇦🇼', '🇦🇺', '🇦🇹', '🇦🇿', '🇧🇸', '🇧🇭', '🇧🇩', '🇧🇧', '🇧🇾', '🇧🇪', '🇧🇿', '🇧🇯', '🇧🇲', '🇧🇹', '🇧🇴', '🇧🇶', '🇧🇦', '🇧🇼', '🇧🇷', '🇮🇴', '🇻🇬', '🇧🇳', '🇧🇬', '🇧🇫', '🇧🇮', '🇨🇻', '🇰🇭', '🇨🇲', '🇨🇦', '🇮🇨', '🇰🇾', '🇨🇫', '🇹🇩', '🇨🇱', '🇨🇳', '🇨🇽', '🇨🇨', '🇨🇴', '🇰🇲', '🇨🇬', '🇨🇩', '🇨🇰', '🇨🇷', '🇭🇷', '🇨🇺', '🇨🇼', '🇨🇾', '🇨🇿', '🇩🇰', '🇩🇯', '🇩🇲', '🇩🇴', '🇪🇨', '🇪🇬', '🇸🇻', '🇬🇶', '🇪🇷', '🇪🇪', '🇪🇹', '🇪🇺', '🇫🇰', '🇫🇴', '🇫🇯', '🇫🇮', '🇫🇷', '🇬🇫', '🇵🇫', '🇹🇫', '🇬🇦', '🇬🇲', '🇬🇪', '🇩🇪', '🇬🇭', '🇬🇮', '🇬🇷', '🇬🇱', '🇬🇩', '🇬🇵', '🇬🇺', '🇬🇹', '🇬🇬', '🇬🇳', '🇬🇼', '🇬🇾', '🇭🇹', '🇭🇳', '🇭🇰', '🇭🇺', '🇮🇸', '🇮🇳', '🇮🇩', '🇮🇷', '🇮🇶', '🇮🇪', '🇮🇲', '🇮🇱', '🇮🇹', '🇨🇮', '🇯🇲', '🇯🇵', '🇯🇪', '🇯🇴', '🇰🇿', '🇰🇪', '🇰🇮', '🇽🇰', '🇰🇼', '🇰🇬', '🇱🇦', '🇱🇻', '🇱🇧', '🇱🇸', '🇱🇷', '🇱🇾', '🇱🇮', '🇱🇹', '🇱🇺', '🇲🇴', '🇲🇰', '🇲🇬', '🇲🇼', '🇲🇾', '🇲🇻', '🇲🇱', '🇲🇹', '🇲🇭', '🇲🇶', '🇲🇷', '🇲🇺', '🇾🇹', '🇲🇽', '🇫🇲', '🇲🇩', '🇲🇨', '🇲🇳', '🇲🇪', '🇲🇸', '🇲🇦', '🇲🇿', '🇲🇲', '🇳🇦', '🇳🇷', '🇳🇵', '🇳🇱', '🇳🇨', '🇳🇿', '🇳🇮', '🇳🇪', '🇳🇬', '🇳🇺', '🇳🇫', '🇲🇵', '🇰🇵', '🇳🇴', '🇴🇲', '🇵🇰', '🇵🇼', '🇵🇸', '🇵🇦', '🇵🇬', '🇵🇾', '🇵🇪', '🇵🇭', '🇵🇳', '🇵🇱', '🇵🇹', '🇵🇷', '🇶🇦', '🇷🇪', '🇷🇴', '🇷🇺', '🇷🇼', '🇧🇱', '🇸🇭', '🇰🇳', '🇱🇨', '🇵🇲', '🇻🇨', '🇼🇸', '🇸🇲', '🇸🇹', '🇸🇦', '🇸🇳', '🇷🇸', '🇸🇨', '🇸🇱', '🇸🇬', '🇸🇽', '🇸🇰', '🇸🇮', '🇸🇧', '🇸🇴', '🇿🇦', '🇬🇸', '🇰🇷', '🇸🇸', '🇪🇸', '🇱🇰', '🇸🇩', '🇸🇷', '🇸🇿', '🇸🇪', '🇨🇭', '🇸🇾', '🇹🇼', '🇹🇯', '🇹🇿', '🇹🇭', '🇹🇱', '🇹🇬', '🇹🇰', '🇹🇴', '🇹🇹', '🇹🇳', '🇹🇷', '🇹🇲', '🇹🇨', '🇹🇻', '🇺🇬', '🇺🇦', '🇦🇪', '🇬🇧', '🇺🇸', '🇻🇮', '🇺🇾', '🇺🇿', '🇻🇺', '🇻🇦', '🇻🇪', '🇻🇳', '🇼🇫', '🇪🇭', '🇾🇪', '🇿🇲', '🇿🇼']
};

// https://stackoverflow.com/a/34890276/9931154
// https://stackoverflow.com/a/61400956/9931154
var groupBy = function groupBy(xs, key) {
  if (xs === void 0) {
    xs = [];
  }

  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

var HoverContext = /*#__PURE__*/React.createContext(false);
var useHover = function useHover() {
  return React.useContext(HoverContext);
};

var _excluded = ["hoverStyle", "children", "style"];
// Wrapper that keeps track of weather or not the component is being hovered

var Hover = function Hover(_ref) {
  var _ref$hoverStyle = _ref.hoverStyle,
      hoverStyle = _ref$hoverStyle === void 0 ? {} : _ref$hoverStyle,
      children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _React$useState = React.useState(false),
      isHovered = _React$useState[0],
      setHovered = _React$useState[1];

  return React.createElement(HoverContext.Provider, {
    value: isHovered
  }, React.createElement("div", Object.assign({
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  }, rest, {
    style: _extends({}, style, isHovered ? hoverStyle : {})
  }), children));
};

var _excluded$1 = ["style", "hoverStyle", "children"];

var HoverStyle = function HoverStyle(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      hoverStyle = _ref.hoverStyle,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var isHovered = useHover();

  var calculatedStyle = _extends({}, style, isHovered ? hoverStyle : {});

  return React.createElement("div", Object.assign({}, rest, {
    style: calculatedStyle
  }), children);
};

var icons = {
  facebook: {
    like: 'data:image/png;base64,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',
    love: 'data:image/png;base64,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',
    haha: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAC8VBMVEUAAAD/2XL/13L/2XL/2XL/2XP/2XL/13P/2nL/2XL/1nD/43H/v4D/12v//4D/2XL/2nL/1YD/2HD/2nL/2XL/2XP/2XP/2XL/13L/2HP/2nP/2HD/2nL/223/2XL/2XL/2HT/13P/2XH/13H/2XL/1nP/2nL/2HH/2XP/2XL/2XL/2HL/13D/2nP/2XP/2XL/2nL/2XP/3Xf/3HT/2XL/2XH/2nL/13D/2XL/2XL/2XL/2XL/2nL/13L/2XL/2nP/2XL/2HH/2XL/2nL/2XL/13H/2XH/2XL/2nD/13L/2XL/2XP/2XL/02//13P/2XLgwWp8cE/CqGL/2XL3hGzTtmYoLDjqUWZ0ak392HLbvWhzaU1jN0bzXmnUt2YmLDg2OTzbTmN2bE3PS2DpUGb+znHYumgwLjq/pmG/SFxtZUubiVd+clCsRVfyz28zLjvryW3+0HH8tm/2eGtjXUj0Z2rzYWlKSELz0G+pRFf9x3GynF3WuWdxZ0wpLjn1dGr9xXH30nDNsWVlXklERED51HBhN0b9w3BpOEiznF4/QD/7s29JSEEqLTkuMjpVUkU/MT781nHqyGz6qm9CMT+nk1r+03KSQFE7PT71c2r1bGqCdVDcTmPzWmm9pGA4Lzz0ZGlEMj9wOkmmklr1cmrISl57PEzxzm7YTWKjQ1X7r2/5mm3yVGj+zHH5mW3303D/1XL5nW6eQlT/13L1dWt3bU65oV9iXEiYh1ZKSULvzG58cU8qLzkoLDm7o2Dev2nsyW1aVUYrMDnzXWnyVmhbV0bQs2X8vXAtMTpcV0ZbVkbMsGRvZkuXhlbyUmhuZUu5ol9hW0jGrGPOsmVfWUcnLTj0aWrKrmSumFzzX2nXuWc0Nzz9wXC0fFzwzW5BQj9mX0nJrmNQTUNAQT/Kr2RMSkJqYkooLTjgwGqvmV3hwWq1fFzsym1XU0VST0RTUET+2HK4oF/fv2nau2j0amouMzpsY0vVt2fkw2spLznVuGclSlMzAAAAUHRSTlMA/Gf+m+zCbYv7GQkEEwLq4QZU1O3YPPZMW9o7xw79ziFZrWbVRZhoFK9XaTmZz9Cspw8W+VGxIPLE35rNOvNS9DTxpvhGWEpLU7BQnBdH2RhwO3IAAATtSURBVHjatdp1fBRHFAfwd3e55MLFnbgBSXDXFqh7gV8gEGRwDQR3irsGCB7c3eoeaKluNTXqRqlSA9K/+iF79K47s3e7t3vfv292Pzfv5t2bN0PapKXUczRJTY67DXfY2zVu28RRLyWNzBJeUDc2HZz02LoF4WRYrZBgC1RZgkNqkQERd+eHwofQ/KQI8k90Tjw0ic+JJv3CrFHQLMoaRjrViYUujRqQHs1vh1629nmk2b12+MEeQ9o428NPQU7SoHUH+C2jNfl0SyQMiEwhH+5PhCGJLcmr2hYYZKlt4PmG39DSAhNYWqrGNxGmSFSJdOtImCQykwScHWCaDCfxgmCiIOLEwFQxXP60w1T25vR/TWGypor/F5juTvIQFgu3fr2f/gd+uNa1dz+4xYaRmxVun19krGr+e9Dp24mMsYtT4ZbjUT9Ewe1DVuPVbtCh24vyqNfhFuWuNXLgYUx/Jvv17V7QpNfvXzNZ/zHwYCWXiHh4GjqRuUy5XAafyj6awlwe/wSe4iNIdg8Uul+9xGRflJ+AVyf2fMNkl652h0ISyfLBKR5YzWSbRp3w8vhRm5isemAxOPe56ttQCFwvWcVkv1xRnfzfmGxVyXUIhMqVcQjE1vZksj+g4k8m67kWYiF0QzCEunStlIf/PRUqnnqF1ajs2gVCwTX7CwsEZs565GYQtkPVYzdD8MismRCwhBPRXeDN+7KKyRaUL4QXC8sXMFnV/HngZRFRXX5ZvsRcvltaBh/KZjzJXF7jF39DIoqFwhvMZfX2K9DgynOrmctbUMglSktXJkUme+craPbu+0x2TVnUp1ECFIZyy1KLl7+vidrzUEigelDaWlX5aDF0K+75TNVWKNUnBzg/z4Vf5r4AjoOyEVBNKBUBlUrJCKhkikNAxVEbBNSthACjFlBYetGAGVDiY3CZGXCZn6J2UBjODBjOB7kxuGRnwDX+Z9oWCgeYAQf4hZYNpWXMb8uglC1IdiOZ30ZCySFI1+XMb3sE6TqBr1eY336AUgKl2aC0gomtLC3dsWbNjtLSlUxsBZRszYhyofQE89Rj/aL9G6eNGLRtsPSfwdsGjZi2cf+i9c8yT29CKVdYtoytZC67dp/eVyR5UbTv9O5dzKVyrLBsyQKn5MbHhy05NEDSZMChJcNujCgBJ0tcOl6v7tFndJGkQ9HoPj2qfxSVjuLi96eDkm4HPwMnWK18H9dX0q3vOHBCVDcg6yTd1qluQCgfvEJJp0LwWpEsCbwNf0m6fLABvCT3NpY3/Zykw8fTwYuPcG/EBS5USJpVfAoBq6KVwL1B83c4dwFuolYCWSEyZ6ekyc45ELGSW1hjiAw5K2lwdghEGoWRhwY2iJw5fl7y4fzxMxCxNdDWc1y8WfJq82KNfcc8O1Qc3iKp2nIYKux5OtqayycclQSOTlgOVTH6GrPHTs1WBOP87FPH9DVmyZkBb06OP1K4d9LkiorJk/YWHhl/Et40cpJApsnNcV5KIkzRpjOp6GiBCVrUIVW102FYekFgD3FaFJBXHRMNzn8d8iHF2EFdZ/IpMwN+y8gkDZxB8NMDTtImxuTjXt6DTaGXLSiP9HjI7CP3wF8a4EVb46HJw9Zo8k9EUivfFzdaJUUE+OqJYeFZDXNt4NhyG2aFk1maJdR3ZKcmx3UCOsUlp2Y76ic0I03+BWzg+2eJFSJEAAAAAElFTkSuQmCC',
    wow: 'data:image/png;base64,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',
    sad: 'data:image/png;base64,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',
    angry: 'data:image/png;base64,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'
  },
  pokemon: {
    like: 'data:image/png;base64,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',
    love: 'data:image/png;base64,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',
    haha: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAFelJREFUeAHtPQd4VMXWZ7ZlS8puQiCBJIQ0IECQpiI8FBD0RwQF9CECUlT49QlPhAQsGJQi4EPF3n8VnvLUpyiKCoooqEiTLqRCAgZCS91ssrvzn7nxLlvu3b337gaiZr4vmTsz55w5c87UM2XJ0txbLi86WvFkhFGdF20JWzNv4cdfQYtrMgmsWHGLobrMdse5yobBhjB1Ebl3ytCv120pG8TnGN9Kb89MiTjQvl34q/Of+PgFQgjl01p8ZRJYuXRUQulx6yOFJbU37i+ojLPWOQijFKZVUTJ5/OC93/xc3k2IdFyM3t47M2pLUmLknJzcD3cIwbTECUuAUkoWzLnx/l+P1szcdfBcoq3ByQndG5pMGjf4wKYd5ZneCe5hlYrQXp3NJ7M6WhZhq3jOPa3l21MCKxffEltUUvXStn3nhh8/ZdV5pvqGyJTxg/d8/XN5lm+ScEyn5IiqXpmW5xY99elDLd3TBRk98/i49EOFp17fuudsv8pqu+pCiv8vMn3S0K3rfyi7yj+Yb2rH5IiaK7MsCx57ct1y39S/TszTi25rk1d45t1vd5y+ptpqF+xm/ElDfdUV6TcdLq7q6A9IKO3M+XrdnsMVQwb0zbhvytg+hzZuPnRECO7PGrdpU66mlcm46qONx97cm1eZUm8X7uP9lT/CqKEag05zzB9QoLS9RypiDhZWrZ02eehPHdtHDZ+V+/7ZQDh/9PTHZo8ct2TJhlew4pqCKUt0lK5eZdSrDgRDhOHaUftfbC3rW3qyqpAWzL02WHrNFZ+eyDXuWTftlbc+P7oqWOGzMloiddWqcL36h1AUuE1MGDwytVMUOB1f0fycp2neyrBQ0G0uNGjenJ5QXbMzKyPyrumj2svu64XKYYnUlqkeePyjPawvEgKQGse4efqBLDBHagEoEHA6ZwKUbqFFc5Ol0mjOcPRI9nTkj1XUTozP+29Ph54do9hnUM4crj3MTZcS4wxVwVCaPCIJ+mZFe5KgtDc0OHdgzbnaM+GPE6L0ZS3Ny34Va9WLWLFcLVqtJvCvWd1Ar1MHVRhzhGYrp4CENsY8pZRS2pkgZ1KGCDqNQcY3YCFuFwFottE0LzcS8gu+BErvFGKyA5Z77qR0oSRJcYQAjTQb1nAKaBUVtlkSlgDQkvu6QJj/msD6pXdofvYMAfRmGUXz5sUCrdmMwh/oj8FJI9or7oqS25pssx5+/zinAHO0YY2/jMTSRg1qC1d0tYglX4jnxgX6DHZH91+IbJ5fnPDB/g1yd5kUDhfemwlqlfwxOSneUMzocwrIyX3/57ax+gYpGfIwUSYtPDRVrOvhobx8CitwhnSXV2yzCXLdDnVswG6zq1SmMlMiYeLwJKngLrj4GMMmFuAUwD46d4g4yHypbs4daRAT5RqXpKJhb+R8EceEEdIRLg4kG3ABatYig93l5vjAhDRoHS1dFqz/bx0T/jTLx6WAdm2M70nNOCs9Em7/H/la5+hTUGMNW03zH5Rcy6TyFRRcfsHzyNc1SmiEGzTwyJ0dJaNiZa9+IHcNZ7pxKSC8dezzBr1a0nrg0bs6AWoxCEfDgdo/ouXZEUEQCRkqjk134oAbVNd444B4QJO9JJ5SEyN+5AFdCsjJeaPqso7mEj5BzB/cJxbQHC2WLD2e0jQ4T1+QjtA0kLQ4uzMAeSYU1OdOktYK4mMbux+Wp0sBLJCeYPw/5os5Nthn3yFz4BUjxuIpjKcF2aP8gTRlGqX/UUMDvIO13xiKfPp0McOg3q38kkpvb6p5aPEH63kgDwXEdnAubmUJc/CJ3v5NA9tCx+Rw7+jgwg54lhbkBL+uV8JF/vYZKPxeSlDFcOZgBfXXO3dPtXzmjuuhgBkz1tv6ZFqYzcPH6bQEZo1L9YkPPoK2BSd9RA4dSnM1bMpIi3LjaOm8GGalZHuwsmjk57YGSh6TgyMFFgdYGHl1vCAoG2PbJZhmuSdq3APsOyXeOEOnUe3y3mAYOzQBEuJC0lK9s8Qw/Qca7p4jHZ4o5lqD04mLIBXuUztxqkUSsatKAkLZtMuCQjNCXk0j32zlwq1e7AD52RQH0zqErcEZwm/oH0OcY4hfguEiUNHd0MGYR0iuk2OA1uSiH+LmzFGGWTgt/fT7MnA4Pec0V2ZF72Or30aoxv+CtWbi2EH7N+863YUHZCu9za/0b0IFsJxIIbOjojJSUXiCfPH8KPdJNeL+ggrBKaDzDswnOGuaH0ZmLt8DazeXuSDQgEcn3ZTcd/6Stdtckfjh0QXxCWmJ5mnsJAQfvqF/XBMLn+VEU7A/Tms64XN5YI2n/XExOKUphc9yunt0B+a53JVdo494C58lCipg/vL/bu2XFePa4502JtlFqOVDmgS6oInib5fFcMAajYpmtDexPQUfJ6gABnV5V8ttRhw0GBFGrMXJl8D0MY2tANdOe3KfXPetEAVRBcyY/+Hua3rHfsYTEUJuifMvgX5YeftmxdQlJRhFbV8+syB3khqTeky/Hq1+xL65h3t8y7d0CTyb3fXO2MufFbUwBJxt4CmHPrjH+xMqQbS1SGfnLwZJyHqSvmyYv1IHFCpJfWI7zqcf9UekJU1AAgTKQKuZKpDiERWwBTBobpWZn/MJfgz3wG4JiEiA2EFDBpOUpd+JALiiA7YABskdwtUYJ+DyqMCF2fIhLgFCcqQInxGQ1AL4nNBM0A3Xqj/gQqZJlvB8Pn9on8DbJH35HVLL4HcW5EPEybogGtR5SB+af6YIApWgJovlFElSC+DGgIKcF9BqKbiak5PhXwD2LBD1tST9id1SyippDEBL47MtwpciTg4mGrvoDbTwwSwpGAEVwA7aouHqXinEWmB4CeCJQId9I83LcVmU+RRv328XhKfZ5mDNX+aN1BKWKAFCSkGt6U1SFp8UwxBtAXgieAjO+5eIIbbES5AApQl4eeL9xjNHwvCCCqDFD3fA2c57TW0zF2bpzxZL/wb5+U+JlcpHAdxJgXrbu4jgdd5cjERLfEAJ4BhK8+feLATnowDI2/kAAl4hBNwSF4QEqOMlWpLrU6k9FIBnNhNwr3R+ENm0oIpJgEJrsNUu8k72UAD2+2zQDdlKt6KqAYpP1ALen/XOt1mHnXia4eSZOig9aYWGBtfWePA8U7jb+0ysyxTROGel41AJQWWEbyLAGx8Xw382HIciFD7vuuK25u3DEmHsdQlo3ONjm5dfWlYLz7xXCF/+cBIqaxsrTZhGBQN6xcA//p4K3TOCPD/G9lRow2NY6lF8yV2iwDM1b6HsJ/IJSnxWgEkLdkF+SY0oep8uFnjt4R4QFYGnwZuR+/S732DOU/uhDiuQkGOCmjkuDf4Z7OE0PJoOGk0m6bDkV5YPdy6GnTDDldvrfJglyHXnKurh5tnb4GiZ1S/qifI62LrnDIy5tp2imyV+iStM3PDTKbhnyR6wex2k8ib3076zoFGp2IEF7yQ5YdQl1SxYuZU7otg4Bjis4zFSJ4eKN+wjLx2CE6frvKMFw/vyK2Hlv/MF0y52JD6sAbOf3ie5412xOg8OFFYGxyal42jJCgMj0qgApzOoW4ysy/kMj+LJcW98UgKVNbJuRckhLxn2zU+KoQKVINWxRvIcjhNBOQqRUPcbt7uowk2WJCQm6UKaWKZf4KAld+iurbPD5p2nxUhetPj1yLtct2l7OdjqRQ+RSyRHRjJAFZ54GCoRQxRsb16FaJq/BHxlxF9yk6exGduvxey4qDzHBmoleJ650CEsjNMi0t8zQX4In66Rj4QYpxXiKcpMAOksThyUujNB4HJ54sKMFszLUOGucE+lTPB4JrykpsSxy22X0pn0yvNXWmaP8lJ7DxyEaYZHpIJAcjtl9waS2yrDU8CiIEpkuAbwzR7BtECRHeJDwDtVZWIXdOERikCZiqUP7OX/XpQY3jUK8cToKYlXwgO7BdMan+cJ2lFnUuM0NEhKeIgX0hLlmZCu6RULqTJxgmRTEH3qyGTBeH+RU0e295csPY1AXEgUwGw7j/+v9DcTTAY1zMe7xs3BdUmNgIk3JEpm5UpcBbM3MkLiKDGFRAGMGfZe0OJ7uwQ0L+BzvfDC3O6QkhBcH1pnc3DWylNnbID32YKSx8NYGYZcERuQRiZ2Pc/P6w54eyggrDQAqiP0yBy5ayi/tJm9ZP6Lh+DIMd/5NTPEPT69M3TCgihxDgeFZ9cUwodfH4cSNBXzToMPKPXE19KyJ2ZAb8xDiWMm6Fc/Kkb6BVBd67nIYvTHD0uCORPSwWQM5bUy8n3IFcAXfvfhCvgF/85V1kOsWQdXdLNARntlgudpMovlfcv28kEfPynOAN+9NsAnXk4Ea1l4QREKSmtwPx2vZyJNNl5xz7HJISQJlnyufCIcIIMe+KYa+wulY4N9f7x1suWXMz5k9VoVZ7P3SZAZoccu8rq+bWRiKQQn8BvBfYBanIpyljmFZC462ndYQz/YeAK7uSrAh++AKWY0DoyxMp6MuehMC2ZI5qMCsnfi+Z+gV8OC9FsiA0hAPYbNgnYGgGpJbioJaNQ72BjwPf7dJTUPZ40T7Ocp0HonqCNVoLHgrCBkk1mpXFx6OEeVE2yFdrCfdeI2LwWVgUBYew3oElGkUmapeGyRpCw6qsGzi1+BAykEeB6g9pd6qNhcC/Uldg/bvyqMgKGjDsL7hIGhszy7Sg1O9175qIhbO0wbnRzo9cWQSX3jtnL4bvdpuBW3RbumybsDXbu/ASq/rQNbcYOHHHjmNBYVRA83grF7QFl8wXA4XeFAjLdeoC9PxMPHufept6qg9mBg021YAhq3bjZhTZC24T4ftzHfXneMy469vvjqwz2BGcia0r2Gc/2Frx/msojCvHa8Mwi0+BJMIGcvd0D5uzVgOyZt9yxqoB4sN/hdbN5IMpav+720ZBVaRQUVUL66WpLwWQFspXYoe74CzENMEDUk8MSq+vejHwx32/5zMPDu7+GeW1Ng1MB4sAhYKdmG/k/7zsCOg+ehDFfA+EM4+HqtCswROnx0MBzYQo8tyLzfMcXHxeFHXCCuxK3E7QfOsew4V1eH3anDgQrwr/TavfVw+r0acNZLX7NWbKoDbWs11zPw+bl8QsohLfVLFm5sAUfnWqDeWYqzIQ+V1R1ugLJXle12RV6lh+hR/q+SleAJitHZ2+DUWZuLN/bBVvqdO0RC29gwCDdqcc+2AfJwZe2++vVAcAuwd426pUZBXCs9mgwAypH2gYIqqBI4HMbsVxMC2IFqdtvgNNZ8qsDaoQ5XQeLD+I6ct34J+RfeH57N2Ha1PZyO4quB9B63skD521VQs9dTOO7pgb7NgwxgHubfSsrOEk1f8gvsRyFdLMeMgYvuyQT2Apg/x/r5sheqFAmfpxs3LQL06W5dMgEHqHWpbABmMBfmLxrVcgx7HFOoy/cI8jQl+xXfWMF62P/YwR6BWruiL2cjaherl0Rb6ck6dsrt7/jw1MYX+wcUvtNKoXyVsprvXgjbUa8xg5JVvPAZnKsFsIBHK8AmV5wd/KkFNk1NyEEDmXczZBl6OYpdLOvfP0Bj25qvSr1SAfQqNfQyhkMnQzjEabSgwz7G6nTCiQYbHLTWwN7aKqhnRLxcaoIJZt6WBgP7tAJ8qt8rVTh4fn0tnP9a2jknYQqNsVEDcDAewffspB50uk4keWERj+PJjUE9H2rtYzERL5rhvBTVI1AeHleSbz/ngKqf6yACx4RAjuXHXh7snWmGH/aehRLsnpiL0mhgfHQcDI+K4ZQgRqfa6YDPz5+G1WfxbKfjQs1jwh9xdZwYmk88q/2VW5R3ve4Eid6tjhO6wl34DO5CF4QBkrDkDLaJHI4AmmDZQisUrnq7vJrEFJEzMZ3LekC4GVZ36AJjLK39Cp8Bh2MLuTW6Dfw7pQuMNDfa99Nx1+2G/vKMa9ZD9eC0+bYkJbLQxrjM10UQ0XqhNw3PFoCpeMv7NVwXjMZ1wfX6FC1U4ywgWGfDxZujAlfOUdIVOnxAHNB8B3Q9EHBB48OeCRXxzzaJ0NEcDlffHw/sBxfkOOuvwY19fF4sV30GipgdyAX1FBI3p4ZP430RiWgmIlKJsWsINp5/z6nh5IUugc88kD9sdDzo4nzqSCA0V/q44e2AbTnKdQ1nFMw5BTIJS0FDQwQn4ly8uP2tAIhnF8QDkPQl5TgZH2XMCqtza0J8siLfUSW/SbMW03amGSL76oGIVBUhZph5JHZsBJiv9z8FFsJlcU5raBRgHoqLUQJrIW3Z42J5iRaLpC7bgYfXp5uv50dwMRLS4on8noQjTHQEYsZEQLtZFjB11flVhAoXYUxZiQ9G4wo08KAvxrnaICoWMRSfeGMXLejTtL+CmUzw95OPfts3SVv2Fj2S08Z6sH5psGOBNtY1GPkwKyVCG6+B1pPxV7LQGmvFFXr9CRxXqhtrKpssMDsUMwoSrP3BOh3SqvOev8sgqsGW2+qW8KOg0g0lsYv8rjD9KoDlSTKWLnPsnG1sOO14lA2mSpw2Wg3aIPpy9zxVeJDD1DOM+3OPD+W3KUsHlVvlzdz4/NXIX+vJkSdU5rCrccFVwseL+ZLamrrXk7ltJkUt0icF1JdgPlIMc4KIlygyLFUDrAuR6zRmFbSZFnFCl2Lo777a9UdHVnul+2ZPPftF7ctV31ul/dID5hzeIwxa3S5/JuKP6YuR5qx1wsmXq8B23POIiljeJrT/R482/qyODBvh720Ib3xZCmDINH9eP1uB7dPzG2os1iPidh6Cc+/IvxnAMgwHcUntzJu1Sx+muBg7/6UVuyMbUNwX8XZsZmbopIWoaw2AeyCrARKmkvQZshZOshXAmOB+otDuWNVw0tGvdj+eTCtx4NZcY01RGQnoU7VgwpqvubAK9Ob9DxV21lCwHmmAhlMOoHW4/YhmZm0rFS6ytIDlZQKfhwvYp5QUSpECWEb4hr8K8q3Z+LEAQwonmUpYblY4+BK7ajxJX3pAKVeKFcBnSAtzuoODvomK6MHH/fl9tGoCLIf01AWETAvKbhG0ApiwG1tD7WT8WohWD+lmxz+ipgj5GGv9HJL2RH4o2A+JAnhGuJ+lOg/zMDwTtRKaJTRP/FL7hOxCs8JsXJxuCiUrIVUAzxj7XRew2u/F1nAfxim7PsMTu+Q++Rpr/DI0pn3VFKw0iQJ4Rrnb4HUnp2DXNA1bRDc+vtn7hOBOEP0v8vkUzm52NSW/TaoAd8Zp0YOX4XnvCViwcc1ynOBs9uRb5O0d/KmgD0jsMr82HPeyBfN90RTAM8k9iZa/vT+Gr0dL03WokMuw0BedD44fAufRZ10M++Fm9tR8Kc/nxfIvTcHdSocPnLbB01GDUQW9URl4Shuns+wthVC7xhrOZi678HL6Llydb4HUXtsIuVWarSHU/PxO75IrwLtcjc8kz8OfsnJmolKSUCGJ4CT4O2L4TbFzINzsysD9nhih7Pgdmmixz8bFKsIwH39HjOLviJFjKORjmFYCKmcROEx7SHpupXd+lzr8/54j5QS8F7YsAAAAAElFTkSuQmCC',
    wow: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAEsVJREFUeAHtHQl0FFWyepJJMrnJQUhCQriScAQIBFBAFESQQ1EhqLiK4PNaXcX1WDx2fa5vfayrqKjsrroq3lyCgCg8Flw0uBzKtQHDIZATct+ZZI7eqp4jPTPdPT093cko+e8l3fN//fr1q/7V9evXZyBAwxdVVVEmU1sWC0wWAJsFLNCzL8swUfiMYlgmisUnkc8A08QybBO+NTEs9yzFyCL8XcQAW6TXG4rmJiZieuAFJlBI2lZTE91iapsMVutUlmWnMAwzEp+q0Ie4EBV7BJ+7QafbFaE37JkVH98YCHVXpYJKK7K2tjaGMbbkY0u+HXFMBJYNUorLp3wMY0H4Auw5H7JhEesWxMU1+JRfReAuFwC16g0XSmeyVnYRMv56rEuYivVRgsqIgtjM6JjV8/r0/Yp6ixIkSvN0mQDWUuuuKL0Zx+SnUAjDlBKsZT5kfiHOOS9Act81C2y9RMviONyaC4BjfHnpnThxLsO/QZrXSJUCmNM4gS+HlL7vay0ITQWw7mLZBNZsWYWMH6kKX7ocCXOECQ76bX5S6l6titZEAFvKyxOMrPmvuBRcTGO+VsR3BV5uTmDhvTAm+A/XpaRUq12m6sxZV1Y8F2exd7HVx6lNbPfiY2qRWUvyU9O/UJMO1QRwkGX1ZytKXsQWv1RNAgMNF/aIV/snpz2RxzAmNWhTRQAbKyoyTKxpDa7jx6lBVMDjYJj9ekZ/843Jyef8pdVvAWyoKB5rYWEbMj/BX2J+UfkZpjqIgVnzktMP+EO3zp/M68qLpyPzd11yzCemYYOjuhMP/OGh4h6wvqz4VivDrkYlmV6MANZqhQtni6Gm4gJYzRaIS06CpP7poA8JEcvSrfGm9naO3roLlRCkD4aE1GTo3S8NcNwXp4sBk45lFs1PTf9UHEg8RQKzeCZiPi4uPxZbYjZW18D3W76G/Vu3Q2NtnQuisPBwGH3NVTDtjlsgKq6XS1p3/WioqoEdqz+BI7v2QHub0YWMmMR4uPy6mTBuzgyI6hXrkub4QUtVVGDcpkQIPguAuhzqcLYKtXwUCBR8vhW2vb0aqDVJhfDoSMh//GEYPukyKTDN0w4j0ze8/CYYW1slywoNN8Cc+5bAZdddKwyHPQF1SnPyU9J3CAMIx/okAPuES2N+pBC6D55dDsf2FAglCcbpdDq45clHIHfaVYLpWkfu+3I7rH/pDZ+KGTN9KkezYCaGacaJeaovE7PsSZiWmvbVjiDzj+/d7xPzqQJWnCPWvrgSGqtrBeujZWRtxUX4/JW/+1zEDzt2welDR4XzYcMkHhGvhAE8Y4M9ozxj6CPr54oSWueLLjWNLS0eGXun94XJC26AATnDQR8WCqcO/gjb3/sEGnCOcASzycRN0tEJXfvhXFlcClYLbQt0hrg+SXDNnQshc8xIHJLa4Awyes+6TVBdVtEJhG/GFonhCnlkAtMa5NkkOR9rsgRAX7jIfMmPrJzJE+CbzzZAxc/nuVXDlFvnwfTFt0FQcGcRY2dNh6xxefDeM89DaREqHDHEp/SBtMyuV5Jm5AyB2N4JUF9pU+/0zxkKi55/CiJiYji6ovE/NaCxs66BbW+9D9+u38zFp2UPhuzxY7h30X/IK45nAI+IwtgTvM4BNt0Ou8kbIkqn1ny+8CeITUyAeFzCiQWLyQwHt/8bjM0tkDfzamelxeC1im+qqYWDO3Zj+dGQN2Mq6ILEN+Sqisugqa4O+g3LdmlUUrThpHyDN92RpABIq9nGmnFz+9emWJNim5ppTK2BCc6S0qJKTsKcSrmH+X5IhI2z8VAchWgPoM0UsFi+E/vYEkfZk8LnALefEBQ0SWxTR7AH0DYi7WT1MJ/PSmXvxEPiJbc1K4BCUABg28P9hW4jCtSy26NwS5bjqSchHgKwSYo20HuCuhxglwn1Ag8BkOkIrnq6fmGubm0DEBvylOOtK2kukzCNV+srSo7hU1W7nQv4cXau8ASg8RMMyh3JfXy5khEYv6pKyuDM4WPch2TGiKGQlJ6mKmE4IRfOT07L4SZmO+bOz1SM4CzWVGQ+6XjWvbQSftr3g0tFptw6H2bds8glrrt/bFr5FhRs3OJCxrCJ42H+Yw9CZKywGtoFWMYPatjEYwTd5gB3GYLIXNCR4O+zqa4eXn/gUQ/mE97dn66HPWtlfVz7S4as/DtXf+rBfMpYWLAP3nzwCWhrbJaFRw6QO4+dAiBDWbutphw8kjCkalj9pxecehYh4J0ffOZVBy+UT+24loZG2PXpBlG0pIj74M/LPRR3ohm8JBCPidcOMKcAyEoZI1UxlN350Ro4/78TjjIEn22oPS05cVIwrSsjzx4r9Lp5dPqHI5xWVCW6wuy85tA5BYCSIRNxvwO1/v9u/loWntKTZ2TBaQlUdupnWej3bvwSaI9bjcDnNScAOhyBiCeqgfzof76D5vp6WagqzxfLgtMSqPJ8iSz0dZVVcPx7vyxQ+OVMtPMcOAFwJ1NUOhxxePe3/IIk33VBLoswSVitEqVU0O5l0qa9KgF5zfEckXECoGNBqiBGJBWnz8pG1Qs3RLo7xPZOlE1CuQ9184rUznNOAGjMoJoAmuvln/ZJG5LplU6tAdJxh0tuaG6QXzdvOPGbYArB6Og0ItodjfCWQW66Llh8V4mPg+xtMvNy+VHd8j5kwjhuR0xO4Tre9qoceCkY/BoeSbzXcUdBVbThTxnYX6pcZxoZOzFoltLdIVivh/Gzp8siI1Vm3eQgI7UP8V5nO4crJ4s8mNTB3vV4ZJQ1/roZ8hB2AdTlc2cDWex5C6mDB3gD8SmdeI9NEA9BqxhGTb1CEhutOu54dplq+hXJwmQmknXEbX98TNoGFHGNnDJZJka5YCwKgDuBLjeDdziyGhg/W7h147gHNy29HwaODry9nuzLxsKc++8SreAV86+H5IEZoumKEpD3QfmPLv09ZlZV70p2M1azGegr04JPCulDsmDh048C2Q8FaqDGkzF8CFw8VwxNdqNisgm9emE+zLx7kdce4mu9cC+ggVlbXnwUja5yfM0sB77DaAQy9Q5Huxsxy2I5eLoDhmyG2pqbIa5PHwgODdGGBIY5hp+iNocXWpQQEhYGSRnpWqDWHGdUfBzQn7aBjdKR1xFtC+nBLsYB4j0uQ7XrAWIF98TbOEC87/4voUtcGrhNzgSkI6NLQS7EezxfRh6mekJ3cIB4j0NQTw/oDubbysQeYPOx1n0kXMolE++pB5Reykzo3rozpcGcd0HWPzJq0HTjizfe5j7hOUyo86GzzaT7EQuojnUm8V6dcdyLPYEs6qLxo2gcHnHKu/ZqVxiBX+b2Ds726MBXO8GM58CCUQHI0J+DJo4+G22uJHbSizWwYXYA4E8d0qHTBYEhJgpyJk2ACTfMEijdhyj07IhfwgydgPEhlyfoptf/KWiA5QmpPKam/AKcPXYc6Fxv/uMPAW3oCAU6Jrtl1btQd7FSKFm1ODJVoaNYQydKHp3zUh5TFEx+Nf1jP0Cb1KlBLyT4mlx04Ed4efEDcP3v7uHOdTnykwJt0+tvwekfjziiNH9WlZX5VQbxnqFtsQ5TWwPt0CjFduL7/fDx83/zOOavFJ/cfENxO3H2vYvRDmkbFGzappr1mlT5dLiczjdTD3xo1QpQeryWDHRD9IYYjulry84fwkJHSRXsLY2MlmhDvsPYzjnmsILNiAlnemfWslNn4JO/rHD+DrSX6Ph4uPvF51A53EkzqgtwhMb/9jirxYrvVkgekAH60FB/qnB4QWq/XJwDuMlyNxbglwBof9eb842oOOFx259aqJm3/4gh0GdAPzVRiuLCHrCbEm26IHTnKwqpYoIhKgJd1vRREaO6qAaO1GRbRJhIO885AZAvZVyjWYQh1Y3tFwC2QGI1GpirmnWOWBG2eOQ1x3P8xQnA7shavpsTafSSqf1HqHr4RrIsXxJpMiXXBO5hQHgkzElKhQm9EuzDhTuEot8FDufhtiEIceCHx4eKUPmYaUBuF3ZzH2gbPFp4ChwRHQuGIB2kGgyQHGbwAaM4KJ/XTgGQF3HMYhTPpk4KnbsS+4hSpwRlWLLGjRbM2Gi2eae04mKo2W5gIAgoP9Jo5zWXwykAcuGOkrG5BJGPTBFkNnpMCaRAa/usPGEBfFdTBT/U18Gu6ovQYBcGn/YQBnsH9ozk0DAIdqgt+ABu78Rjvrt8bhnqgCEX7niGaYHjt1bP4ZPGA3mrCpRAw2I46neEQgeu+X9uFT4jNjgiCmiIQhURFzqwmxxqqIXitlYhVFwc8Zif6OwBFGn3n1/IB9DifdCYUWCIFHS8pUVxXnHmKrB4S8FWPyqmk/lUSAhKYmxsPMTphc1YcO1fSDzmE+TaA/DzeG15yQv46fcxH0jtdzKIzZ02Gfai+kBuCMHuPSI8CjLDwiEjBM1dsJIGHDoMTBC0YyttRq1nuakdThlb4UBrI5R2tMtCTQ6lcib7fjgoE1u/UKDeMDAiEmrraz2S6W4CUkHwE1wEwCXg5QVQXvIcCmEQH1Dt93Ezp8sSQC4yfW5sIozHCoehKlgqjIRImBlj+9o+3NoEW+ur4dvmeujgqRbc82eOHQ30gehrMEic7gkXTMM7CYi3bsFDAHRhwdqykuUogHfcYFX9mZo5kLO1rDhzThDvwFADPN6nH2Rhi1cSRqHg6K/eYobXLpbAN011gmj4pumh2KNycEyPDtbDxXYjHG9qEFXUtyLeSJGzEG1uvuhsBTPLhS6DcJkDnBTizRH4ZaC5Xpd6gXsIwqHm9vhk+Ee/bMXM5+OMxdb4bEp/eDo5AyJ1ru0tMS0VSKPqCBPjEqF/eATEo2ffoVHR3ATrSHN/nm4RtmWgznbKIw15yfHUHYtDF+QWT5KimyPcxys3ML9/jpkxBbt/52SciC1vVXoWLElIlrWk84WAadFx8E5GNvQN6dRgXrngRueuXRi2fmI8P6RI9L4yYxscaagHM30g2AO976urgTpThyOK8LPES6HWT0DCPQATOA9PeHOEE5MGL7QSIr8RFOKQ+S+nDeYmWQ2K4lDSxL0iLROS8UnGwqOnT3EWZULm8ZlJCW04zEiFk9jSt1WWQ0FNNRTUVsOWi2VQgosAl4A8FPOWRXCiAqBEurYDPxxq6F2rMOmmOdAXt/ZWIPPTcHWjdaBe9goKYeYNc1yciFtwtD/UUAeOBt2O+xtHGr2fdya48vY2KMceYXab7Il3xEOpOuGiSTr44rZSGpN4asvK9+HK42fFAVROKWctUPbaM8Cg9bZ7oKEoApem9eiC0+LGUHdYb79RAF7dVkr2ACqA/F7iOPaqt8L8STfctxDOWlW5EcQrGTRin7r5WkHmU2Yjtuiajg7/mY888+YzlMrzKgACojtTcDbZT+9aBB1Ofqfmz/C70nJo2xcfCRFTJ8kBVQ6DvOJ4JgODLAGQD2S6MwWFYPPzKwOxryBx06+EvUlOLy6+ZpcFX2G1APPEvbJgFQMhj4hXcvxGUxmyBECAdGEN3ZmCQhDWTBGQnyH0yQfgpM62me8nKo/slRYT/PTQbyAIj0tpFmzu62f5crmPbAEQ0eQXH2ftebh7o8mArTOEQc2zD0MFTpJqhjpcTv64aC5EDc9WE60rLu4CB5jny90BhMAnAVAGuiGC7kzR6iNNn5QAZ568D4pVEkIDTqqHl9wECagC1yoQL4gnvt6eQfR4XYaKES3nEh+xvHLiLbUNEPrcqzCqXfmQ9BNqHqqWLgbDoAw5RSqDwZZPzFdyfwwVqFgAlNl2nwxsQEulTn0CJagYWv+1BobtOwrxbnocqSKqrGY4mjcUYu5eiDX0q4pSxRDuZhqSlbR8B2K/qeuKi9zMeM9Ax0cbofexkzAItQNCW39NOGSdDg+F2rzhEJs/B9Duz1FHbZ4qXeTmtwCodl15laGFhHHyLJhLygBMaHreKwrY9FQIV9mRhqTUAukqQwehPZd5Ojjh21OVHsAv8td6na1dKXmXHPUCnx/e3n1ehnpDSATStR1I8LtaLVW90aBmOtWB6oJazWy1mU90qt4D+JXvudKczw3hd00FQEVyPvNtF0Is03qjX7iKSmJxAx2Y5bSNKLaTpQSrUB7NBeAolBME+s/HYzlP4VmEgLTQxeGmkExHyHpBa8Y7+NJlAnAUiMxnODf56Kkdz51cj/GeuyIO4K55GnGM30wWa3bDtM5N3i4ov8sFwK8TeREnR9YoiNsxfiJ+UUsb/vAz+/NuOwtRgIz/kAxl+baa/qBVkrdbBcAnmHwpc+580aMs7gROJUM46i18GKXvtJJBnEcR5y486LuLDkc47POV4lQrnyoVVIsYPh46vcn5NEXXjjh5Z+GeOT37sgyDCn02kpwdYc/h7AOxJTfZnI4wTTbXC3j6Hw9B40RaREdB9XpD0dzERGFDHn6h3fD+fzytZTGr/fCsAAAAAElFTkSuQmCC',
    sad: 'data:image/png;base64,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',
    angry: 'data:image/png;base64,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'
  }
};
var icons$1 = {
  find: function find(scope, name) {
    return icons[scope] && icons[scope][name] || 'n/a';
  }
};

var emojiColors = ['#b7e887', '#b5e0fe', '#f9ef67', '#f3c1fd', '#ffe1ae', '#e0dfff'];
var sectionSlugToName = function sectionSlugToName(name) {
  var thing = {
    mine: 'Frequently Used',
    people: 'People',
    nature: 'Nature',
    'food-and-drink': 'Food & Drink',
    activity: 'Activity',
    'travel-and-places': 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags'
  };
  return thing[name];
};

function listOfNames(names) {
  return [names.slice(0, -1).join(', '), names.slice(-1)[0]].join(names.length < 2 ? '' : ' and ');
}

// https://stackoverflow.com/a/53453431/9931154

var withActive = function withActive(Component) {
  return function (_ref) {
    var props = _extends({}, _ref);

    var _React$useState = React.useState(false),
        active = _React$useState[0],
        setActive = _React$useState[1];

    var handleMouseDown = React.useCallback(function () {
      setActive(true);
    }, []);
    var handleMouseUp = React.useCallback(function () {
      setActive(false);
    }, []);
    return React.createElement("div", {
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp
    }, React.createElement(Component, Object.assign({}, props, {
      active: active
    })));
  };
};

var ReactionBarSelectorEmoji = function ReactionBarSelectorEmoji(_ref) {
  var reaction = _ref.reaction,
      onSelect = _ref.onSelect;
  var node = reaction.node,
      label = reaction.label,
      key = reaction.key;

  var handleClick = function handleClick() {
    onSelect && onSelect(key != null ? key : label);
  };

  return React.createElement(Hover, {
    style: wrapStyle
  }, React.createElement(HoverStyle, {
    hoverStyle: labelStyleHover,
    style: labelStyle
  }, label), React.createElement(HoverStyle, {
    hoverStyle: iconStyleHover,
    style: iconStyle,
    onClick: handleClick
  }, node));
};
var wrapStyle = {
  padding: '5px',
  position: 'relative'
};
var labelStyleHover = {
  transform: 'translateX(-50%) translateY(-10px)',
  opacity: '1'
};
var labelStyle = {
  position: 'absolute',
  top: '-22px',
  background: 'rgba(0,0,0,.8)',
  borderRadius: '14px',
  color: '#fff',
  fontSize: '11px',
  padding: '4px 7px 3px',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  left: '50%',
  transform: 'translateX(-50%)',
  transition: '200ms transform cubic-bezier(0.23, 1, 0.32, 1)',
  opacity: '0',
  fontFamily: 'sans-serif'
};
var iconStyle = {
  transformOrigin: 'bottom',
  cursor: 'pointer',
  transition: '200ms transform cubic-bezier(0.23, 1, 0.32, 1)'
};
var iconStyleHover = {
  transform: 'scale(1.3)'
};

var ReactionBarSelector = function ReactionBarSelector(_ref) {
  var _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? defaultProps.iconSize : _ref$iconSize,
      _ref$reactions = _ref.reactions,
      reactions = _ref$reactions === void 0 ? defaultProps.reactions : _ref$reactions,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps.onSelect : _ref$onSelect,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? defaultProps.style : _ref$style;
  var emojiStyle = React.useMemo(function () {
    return {
      width: iconSize + 10 + "px",
      height: iconSize + 10 + "px",
      display: 'flex',
      alignItems: 'center',
      fontSize: iconSize
    };
  }, [iconSize]);
  return React.createElement("div", {
    style: _extends({}, wrapStyle$1, style)
  }, reactions.map(function (reaction) {
    var _reaction$key;

    return React.createElement("div", {
      style: emojiStyle,
      key: (_reaction$key = reaction.key) != null ? _reaction$key : reaction.label
    }, React.createElement(ReactionBarSelectorEmoji, {
      reaction: reaction,
      onSelect: onSelect
    }));
  }));
};
var defaultProps = {
  style: {},
  reactions: [{
    node: /*#__PURE__*/React.createElement("div", null, "\uD83D\uDC4D"),
    label: 'like',
    key: 'satisfaction'
  }, {
    node: /*#__PURE__*/React.createElement("div", null, "\u2764\uFE0F"),
    label: 'love',
    key: 'love'
  }, {
    node: /*#__PURE__*/React.createElement("div", null, "\uD83D\uDE06"),
    label: 'haha',
    key: 'happy'
  }, {
    node: /*#__PURE__*/React.createElement("div", null, "\uD83D\uDE2E"),
    label: 'wow',
    key: 'surprise'
  }, {
    node: /*#__PURE__*/React.createElement("div", null, "\uD83D\uDE22"),
    label: 'sad',
    key: 'sad'
  }, {
    node: /*#__PURE__*/React.createElement("div", null, "\uD83D\uDE21"),
    label: 'angry',
    key: 'angry'
  }],
  iconSize: 38,
  onSelect: function onSelect(key) {
    console.log(key);
  }
};
var wrapStyle$1 = {
  backgroundColor: '#fff',
  borderRadius: '50px',
  padding: '2px',
  boxShadow: '0 0 0 1px rgba(0, 0, 0, .05), 0 1px 2px rgba(0, 0, 0, .15)',
  display: 'flex',
  width: 'fit-content'
};

var ReactionCounterEmoji = function ReactionCounterEmoji(_ref) {
  var node = _ref.node,
      bg = _ref.bg,
      iconSize = _ref.iconSize,
      index = _ref.index;
  var emojiContainerStyle = React.useMemo(function () {
    return {
      zIndex: index,
      position: 'relative',
      boxShadow: "0 0 0 2px " + bg,
      width: iconSize + "px",
      height: iconSize + "px"
    };
  }, [iconSize, index, bg]);
  var emojiStyle = React.useMemo(function () {
    return {
      width: iconSize + "px",
      height: iconSize + "px",
      objectFit: 'contain',
      objectPosition: 'center center'
    };
  }, [iconSize]);
  return React.createElement("div", {
    style: emojiContainerStyle
  }, React.cloneElement(node, {
    style: _extends({}, emojiStyle, node.props.style)
  }));
};

var ReactionCounter = function ReactionCounter(_ref) {
  var reactions = _ref.reactions,
      user = _ref.user,
      important = _ref.important,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? '#FFF' : _ref$bg,
      _ref$showReactsOnly = _ref.showReactsOnly,
      showReactsOnly = _ref$showReactsOnly === void 0 ? false : _ref$showReactsOnly,
      _ref$showTotalOnly = _ref.showTotalOnly,
      showTotalOnly = _ref$showTotalOnly === void 0 ? false : _ref$showTotalOnly,
      _ref$showOthersAlways = _ref.showOthersAlways,
      showOthersAlways = _ref$showOthersAlways === void 0 ? true : _ref$showOthersAlways,
      style = _ref.style;
  var groups = groupBy(reactions, 'label');
  var names = reactions.map(function (_ref2) {
    var by = _ref2.by;
    return by;
  });
  var nameString = [];

  if (user && names.includes(user)) {
    nameString.push('You');
  }

  if (important != null && important.length) {
    if (names.includes(important[0])) {
      nameString.push(important[0]);
    }

    if (names.includes(important[1])) {
      nameString.push(important[1]);
    }
  }

  var othersCount = names.length - nameString.length;

  if (showOthersAlways || othersCount > 0) {
    nameString.push(othersCount + " other" + (othersCount === 1 ? '' : 's'));
  }

  var nameStyle = React.useMemo(function () {
    return {
      fontSize: iconSize - 8 + "px",
      marginLeft: '8px'
    };
  }, [iconSize]);
  return React.createElement("div", {
    style: _extends({}, counterStyle, style),
    className: className,
    onClick: onClick
  }, Object.keys(groups).map(function (reaction, i, reactions) {
    return React.createElement(ReactionCounterEmoji, {
      key: i,
      bg: bg,
      iconSize: iconSize,
      index: reactions.length - i,
      node: groups[reaction][0].node
    });
  }), !showReactsOnly ? React.createElement("div", {
    style: nameStyle
  }, showTotalOnly ? names.length : listOfNames(nameString)) : null);
};
var counterStyle = {
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center'
};

var FacebookCounterReaction = function FacebookCounterReaction(_ref) {
  var reaction = _ref.reaction,
      bg = _ref.bg,
      index = _ref.index,
      variant = _ref.variant;
  var reactionStyle = React.useMemo(function () {
    return {
      width: '16px',
      height: '16px',
      backgroundSize: '100% 100%',
      borderRadius: '8px',
      backgroundImage: "url(" + icons$1.find(variant, reaction) + ")",
      boxShadow: "0 0 0 2px " + bg,
      position: 'relative',
      zIndex: index
    };
  }, [reaction, bg, index, variant]);
  return React.createElement("div", {
    style: reactionStyle
  });
};

var FacebookCounter = function FacebookCounter(_ref) {
  var _ref$counters = _ref.counters,
      counters = _ref$counters === void 0 ? defaultProps$1.counters : _ref$counters,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? defaultProps$1.user : _ref$user,
      _ref$important = _ref.important,
      important = _ref$important === void 0 ? defaultProps$1.important : _ref$important,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? defaultProps$1.onClick : _ref$onClick,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? defaultProps$1.bg : _ref$bg,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? defaultProps$1.variant : _ref$variant,
      _ref$alwaysShowOthers = _ref.alwaysShowOthers,
      alwaysShowOthers = _ref$alwaysShowOthers === void 0 ? defaultProps$1.alwaysShowOthers : _ref$alwaysShowOthers;
  var groups = groupBy(counters, 'emoji');
  var names = counters.map(function (_ref2) {
    var by = _ref2.by;
    return by;
  });
  var nameString = [];

  if (names.includes(user)) {
    nameString.push('You');
  }

  if (important != null && important.length) {
    if (names.includes(important[0])) {
      nameString.push(important[0]);
    }

    if (names.includes(important[1])) {
      nameString.push(important[1]);
    }
  }

  var othersCount = names.length - nameString.length;

  if (alwaysShowOthers || othersCount > 0) {
    nameString.push(othersCount + " other" + (othersCount === 1 ? '' : 's'));
  }

  return React.createElement("div", {
    style: counterStyle$1,
    onClick: onClick
  }, Object.keys(groups).map(function (reaction, i, reactions) {
    return React.createElement(FacebookCounterReaction, {
      key: i,
      reaction: reaction,
      index: reactions.length - i,
      bg: bg,
      variant: variant
    });
  }), React.createElement("div", {
    style: nameStyle
  }, listOfNames(nameString)));
};
var defaultProps$1 = {
  important: [],
  bg: '#fff',
  variant: 'facebook',
  counters: [{
    emoji: 'like',
    by: 'Case Sandberg'
  }, {
    emoji: 'like',
    by: 'Jon'
  }, {
    emoji: 'haha',
    by: 'Charlie'
  }],
  user: 'Charlie',
  onClick: function onClick() {
    console.log('click');
  },
  alwaysShowOthers: false
};
var counterStyle$1 = {
  display: 'flex',
  cursor: 'pointer',
  color: '#365899',
  fontFamily: "\"San Francisco\", -apple-system, BlinkMacSystemFont,\n        \".SFNSText-Regular\", sans-serif",
  fontSize: '12px',
  fontWeight: 500
};
var nameStyle = {
  paddingLeft: '4px',
  marginTop: '2px'
};

var FacebookSelectorEmoji = /*#__PURE__*/withActive(function (_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      onSelect = _ref.onSelect;
  var iconStyle = React.useMemo(function () {
    return {
      paddingBottom: '100%',
      backgroundImage: "url(" + icon + ")",
      backgroundSize: '100% 100%',
      transformOrigin: 'bottom',
      cursor: 'pointer',
      transition: '200ms transform cubic-bezier(0.23, 1, 0.32, 1)'
    };
  }, [icon]);

  var handleClick = function handleClick() {
    onSelect && onSelect(label);
  };

  return React.createElement(Hover, {
    style: wrapStyle$2
  }, React.createElement(HoverStyle, {
    hoverStyle: labelStyleHover$1,
    style: labelStyle$1
  }, label), React.createElement(HoverStyle, {
    hoverStyle: iconStyleHover$1,
    style: iconStyle,
    onClick: handleClick
  }));
});
var wrapStyle$2 = {
  padding: '5px',
  position: 'relative'
};
var labelStyleHover$1 = {
  transform: 'translateX(-50%) translateY(-10px)',
  opacity: '1'
};
var labelStyle$1 = {
  position: 'absolute',
  top: '-22px',
  background: 'rgba(0,0,0,.8)',
  borderRadius: '14px',
  color: '#fff',
  fontSize: '11px',
  padding: '4px 7px 3px',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  left: '50%',
  transform: 'translateX(-50%)',
  transition: '200ms transform cubic-bezier(0.23, 1, 0.32, 1)',
  opacity: '0'
};
var iconStyleHover$1 = {
  transform: 'scale(1.3)'
};

var FacebookSelector = function FacebookSelector(_ref) {
  var _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? defaultProps$2.iconSize : _ref$iconSize,
      _ref$reactions = _ref.reactions,
      reactions = _ref$reactions === void 0 ? defaultProps$2.reactions : _ref$reactions,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? defaultProps$2.variant : _ref$variant,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps$2.onSelect : _ref$onSelect;
  var emojiStyle = React.useMemo(function () {
    return {
      width: iconSize + 10 + "px"
    };
  }, [iconSize]);
  return React.createElement("div", {
    style: wrapStyle$3
  }, reactions.map(function (reaction) {
    return React.createElement("div", {
      style: emojiStyle,
      key: reaction
    }, React.createElement(FacebookSelectorEmoji, {
      icon: icons$1.find(variant, reaction),
      label: reaction,
      onSelect: onSelect
    }));
  }));
};
var defaultProps$2 = {
  reactions: ['like', 'love', 'haha', 'wow', 'sad', 'angry'],
  iconSize: 38,
  variant: 'facebook',
  onSelect: function onSelect(label) {
    console.log(label);
  }
};
var wrapStyle$3 = {
  backgroundColor: '#fff',
  borderRadius: '50px',
  padding: '2px',
  boxShadow: '0 0 0 1px rgba(0, 0, 0, .05), 0 1px 2px rgba(0, 0, 0, .15)',
  display: 'flex'
};

var GithubCounterGroup = function GithubCounterGroup(_ref) {
  var emoji = _ref.emoji,
      count = _ref.count,
      onSelect = _ref.onSelect,
      names = _ref.names,
      active = _ref.active;

  var handleClick = function handleClick() {
    onSelect(emoji);
  };

  return React.createElement(Hover, {
    style: _extends({}, groupStyle, active ? groupStyleActive : {}),
    onClick: handleClick
  }, React.createElement("span", {
    style: emojiStyle
  }, emoji), " ", count, React.createElement(HoverStyle, {
    hoverStyle: tooltipStyleHover,
    style: tooltipStyle
  }, listOfNames(names)));
};
var groupStyle = {
  width: '35px',
  height: '20px',
  padding: '8px 15px',
  borderRight: '1px solid #ddd',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica',
  fontSize: '14px',
  color: '#3D76C2',
  fontWeight: 500,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: '3px 0 0 3px'
};
var groupStyleActive = {
  background: '#f2f8fa'
};
var emojiStyle = {
  fontSize: '21px',
  marginTop: '1px'
};
var tooltipStyle = {
  maxWidth: '250px',
  wordBreak: 'break-word',
  wordWrap: 'normal',
  whiteSpace: 'nowrap',
  font: "normal normal 11px/1.5 -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n          Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
  color: '#fff',
  background: 'rgba(0,0,0,0.8)',
  borderRadius: '3px',
  padding: '5px 8px',
  position: 'absolute',
  top: '100%',
  left: '15px',
  marginTop: '4px',
  opacity: '0',
  transition: 'opacity 0.1s ease-in-out'
};
var tooltipStyleHover = {
  opacity: '1'
};

var GithubCounter = function GithubCounter(_ref) {
  var _ref$counters = _ref.counters,
      counters = _ref$counters === void 0 ? defaultProps$3.counters : _ref$counters,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? defaultProps$3.user : _ref$user,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps$3.onSelect : _ref$onSelect,
      _ref$onAdd = _ref.onAdd,
      onAdd = _ref$onAdd === void 0 ? defaultProps$3.onAdd : _ref$onAdd;
  var groups = groupBy(counters, 'emoji');
  return React.createElement(Hover, {
    style: counterStyle$2
  }, Object.keys(groups).map(function (emoji) {
    var names = groups[emoji].map(function (_ref2) {
      var by = _ref2.by;
      return by;
    });
    return React.createElement(GithubCounterGroup, {
      key: emoji,
      emoji: emoji,
      count: names.length,
      names: names,
      active: names.includes(user),
      onSelect: onSelect
    });
  }), React.createElement(HoverStyle, {
    hoverStyle: addStyleHover,
    style: addStyle,
    onClick: onAdd
  }, React.createElement("svg", {
    height: "16",
    width: "7",
    viewBox: "0 0 7 16"
  }, React.createElement("path", {
    d: "M4 7V4H3v3H0v1h3v3h1V8h3V7H4z"
  })), React.createElement("svg", {
    height: "16",
    width: "16",
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4.81 12.81a6.72 6.72 0 0 1-2.17 1.45c-.83.36-1.72.53-2.64.53-.92 0-1.81-.17-2.64-.53-.81-.34-1.55-.83-2.17-1.45a6.773 6.773 0 0 1-1.45-2.17A6.59 6.59 0 0 1 1.21 8c0-.92.17-1.81.53-2.64.34-.81.83-1.55 1.45-2.17.62-.62 1.36-1.11 2.17-1.45A6.59 6.59 0 0 1 8 1.21c.92 0 1.81.17 2.64.53.81.34 1.55.83 2.17 1.45.62.62 1.11 1.36 1.45 2.17.36.83.53 1.72.53 2.64 0 .92-.17 1.81-.53 2.64-.34.81-.83 1.55-1.45 2.17zM4 6.8v-.59c0-.66.53-1.19 1.2-1.19h.59c.66 0 1.19.53 1.19 1.19v.59c0 .67-.53 1.2-1.19 1.2H5.2C4.53 8 4 7.47 4 6.8zm5 0v-.59c0-.66.53-1.19 1.2-1.19h.59c.66 0 1.19.53 1.19 1.19v.59c0 .67-.53 1.2-1.19 1.2h-.59C9.53 8 9 7.47 9 6.8zm4 3.2c-.72 1.88-2.91 3-5 3s-4.28-1.13-5-3c-.14-.39.23-1 .66-1h8.59c.41 0 .89.61.75 1z"
  }))));
};
var defaultProps$3 = {
  counters: [{
    emoji: '👍',
    by: 'Case Sandberg'
  }, {
    emoji: '👎',
    by: 'Charlie'
  }],
  user: 'Charlie',
  onAdd: function onAdd() {
    console.log('add');
  },
  onSelect: function onSelect(emoji) {
    console.log(emoji);
  }
};
var counterStyle$2 = {
  height: '36px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  display: 'flex',
  background: '#fff'
};
var addStyle = {
  fill: '#4078c0',
  width: '25px',
  height: '20px',
  padding: '8px 15px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  opacity: '0',
  transition: 'opacity 0.1s ease-in-out'
};
var addStyleHover = {
  opacity: '1'
};

var GithubSelectorEmoji = /*#__PURE__*/withActive(function (_ref) {
  var onSelect = _ref.onSelect,
      shortCode = _ref.shortCode,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active;

  var handleClick = function handleClick() {
    onSelect(shortCode);
  };

  return React.createElement(Hover, {
    style: _extends({}, wrapStyle$4, active ? wrapStyleActive : {}),
    onClick: handleClick
  }, React.createElement(HoverStyle, {
    hoverStyle: emojiStyleHover,
    style: emojiStyle$1
  }, shortCode));
});
var wrapStyle$4 = {
  padding: '8px 0'
};
var emojiStyle$1 = {
  width: '34px',
  textAlign: 'center',
  lineHeight: '29px',
  fontSize: '21px',
  fontFamily: '"Apple Color Emoji", "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol"',
  cursor: 'pointer',
  transform: 'scale(1)',
  transition: 'transform 0.15s cubic-bezier(0.2, 0, 0.13, 2)'
};
var emojiStyleHover = {
  transform: 'scale(1.2)'
};
var wrapStyleActive = {
  backgroundColor: '#f2f8fa'
};

var GithubSelector = function GithubSelector(_ref) {
  var _ref$reactions = _ref.reactions,
      reactions = _ref$reactions === void 0 ? defaultProps$4.reactions : _ref$reactions,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps$4.onSelect : _ref$onSelect;
  return React.createElement("div", {
    style: selectorStyle
  }, React.createElement("p", {
    style: labelStyle$2
  }, "Pick your reaction"), React.createElement("div", {
    style: dividerStyle
  }), React.createElement("div", {
    style: emojiStyle$2
  }, reactions.map(function (reaction) {
    return React.createElement(GithubSelectorEmoji, {
      key: reaction,
      shortCode: reaction,
      onSelect: onSelect
    });
  })));
};
var defaultProps$4 = {
  reactions: ['👍', '👎', '😄', '🎉', '😕', '❤️'],
  onSelect: function onSelect(shortCode) {
    console.log(shortCode);
  }
};
var selectorStyle = {
  paddingTop: '5px',
  backgroundColor: '#fff',
  border: '1px solid rgba(0,0,0,0.15)',
  borderRadius: '4px',
  boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
  display: 'inline-block'
};
var labelStyle$2 = {
  fontSize: '14px',
  lineHeight: '1.5',
  color: '#767676',
  margin: '6px 12px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica'
};
var dividerStyle = {
  height: '1px',
  margin: '8px 1px 0px',
  backgroundColor: '#e5e5e5'
};
var emojiStyle$2 = {
  display: 'flex',
  margin: '0 6px'
};

var PokemonCounter = function PokemonCounter(props) {
  return React.createElement(FacebookCounter, Object.assign({}, props, {
    variant: "pokemon"
  }));
};

var PokemonSelector = function PokemonSelector(_ref) {
  var _ref$reactions = _ref.reactions,
      reactions = _ref$reactions === void 0 ? defaultProps$2.reactions : _ref$reactions,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? defaultProps$2.iconSize : _ref$iconSize,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps$2.onSelect : _ref$onSelect;
  return React.createElement(FacebookSelector, {
    reactions: reactions,
    variant: "pokemon",
    iconSize: iconSize,
    onSelect: onSelect
  });
};

var SlackCounterGroup = function SlackCounterGroup(_ref) {
  var onSelect = _ref.onSelect,
      emoji = _ref.emoji,
      count = _ref.count,
      names = _ref.names,
      active = _ref.active;

  var handleClick = function handleClick() {
    onSelect && onSelect(emoji);
  };

  return React.createElement(Hover, {
    hoverStyle: groupStyleActive$1,
    style: _extends({}, groupStyle$1, active ? groupStyleActive$1 : {}),
    onClick: handleClick
  }, React.createElement("span", {
    style: _extends({}, emojiStyle$3, !names ? emojiStyleNoNames : {})
  }, emoji), ' ', count, names ? React.createElement(HoverStyle, {
    hoverStyle: tooltipStyleHover$1,
    style: tooltipStyle$1
  }, listOfNames(names)) : null);
};
var groupStyle$1 = {
  height: '19px',
  paddingTop: '1px',
  paddingLeft: '3px',
  paddingRight: '4px',
  border: '1px solid #E8E8E8',
  background: '#fff',
  fontSize: '11px',
  color: '#999',
  fontWeight: 500,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: '5px'
};
var emojiStyle$3 = {
  fontSize: '16px',
  marginTop: '1px',
  paddingRight: '3px'
};
var tooltipStyle$1 = {
  maxWidth: '250px',
  wordBreak: 'break-word',
  wordWrap: 'normal',
  whiteSpace: 'nowrap',
  font: "normal normal 11px/1.5 -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n          Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
  color: '#fff',
  background: 'rgba(0,0,0,0.8)',
  borderRadius: '3px',
  padding: '5px 8px',
  position: 'absolute',
  bottom: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  marginBottom: '4px',
  opacity: '0',
  transition: 'opacity 0.1s ease-in-out'
};
var tooltipStyleHover$1 = {
  opacity: '1'
};
var groupStyleActive$1 = {
  background: '#F4FAFF',
  border: '1px solid #BBE1FF'
};
var emojiStyleNoNames = {
  paddingRight: '0'
};

var SlackCSS = function SlackCSS() {
  return React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n        @font-face {\n          font-family: Slack;\n          src: url(fonts/slack-icons-Regular.eot);\n          src: url(fonts/slack-icons-Regular.eot?#iefix) format('embedded-opentype'),\n               url(fonts/slack-icons-Regular.woff) format('woff'),\n               url(fonts/slack-icons-Regular.ttf) format('truetype')\n        }\n        .frame::-webkit-scrollbar {\n            -webkit-appearance: none;\n        }\n        .frame::-webkit-scrollbar:vertical {\n            width: 8px;\n        }\n        .frame::-webkit-scrollbar-thumb {\n            border-radius: 4px;\n            background-color: #D9D9DE;\n            box-shadow: 0 0 0 3px #fff;\n            height: 30px;\n        }\n        .frame::-webkit-scrollbar-track {\n            background-color: #F3F3F3;\n            border-radius: 4px;\n        }\n      "
    }
  });
};

var SlackCounter = function SlackCounter(_ref) {
  var _ref$counters = _ref.counters,
      counters = _ref$counters === void 0 ? defaultProps$5.counters : _ref$counters,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? defaultProps$5.user : _ref$user,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps$5.onSelect : _ref$onSelect,
      _ref$onAdd = _ref.onAdd,
      onAdd = _ref$onAdd === void 0 ? defaultProps$5.onAdd : _ref$onAdd;
  var groups = groupBy(counters, 'emoji');
  return React.createElement(React.Fragment, null, React.createElement(SlackCSS, null), React.createElement(Hover, {
    style: counterStyle$3
  }, Object.keys(groups).map(function (emoji) {
    var names = groups[emoji].map(function (_ref2) {
      var by = _ref2.by;
      return by;
    });
    return React.createElement("div", {
      style: groupStyle$2,
      key: emoji
    }, React.createElement(SlackCounterGroup, {
      emoji: emoji,
      count: names.length,
      names: names,
      active: names.includes(user),
      onSelect: onSelect
    }));
  }), React.createElement(HoverStyle, {
    hoverStyle: addStyleHover$1,
    style: addStyle$1,
    onClick: onAdd
  }, React.createElement(SlackCounterGroup, {
    emoji: ''
  }))));
};
var defaultProps$5 = {
  counters: [{
    emoji: '👍',
    by: 'Case Sandberg'
  }, {
    emoji: '👎',
    by: 'Charlie!!!!!'
  }],
  user: 'Charlie',
  onSelect: function onSelect(emoji) {
    console.log(emoji);
  },
  onAdd: function onAdd() {
    console.log('add');
  }
};
var counterStyle$3 = {
  display: 'flex'
};
var addStyle$1 = {
  cursor: 'pointer',
  fontFamily: 'Slack',
  paddingLeft: '8px',
  opacity: '0',
  transition: 'opacity 0.1s ease-in-out'
};
var groupStyle$2 = {
  marginRight: '4px'
};
var addStyleHover$1 = {
  opacity: '1'
};

var SlackSelectorSectionEmoji = function SlackSelectorSectionEmoji(_ref) {
  var hoverColor = _ref.hoverColor,
      onSelect = _ref.onSelect,
      emoji = _ref.emoji;
  var wrapStyleHover = React.useMemo(function () {
    return {
      background: hoverColor
    };
  }, [hoverColor]);

  var handleClick = function handleClick() {
    onSelect(emoji);
  };

  return React.createElement(Hover, {
    hoverStyle: wrapStyleHover,
    style: wrapStyle$5,
    onClick: handleClick
  }, React.createElement("div", {
    style: emojiStyle$4
  }, emoji));
};
var wrapStyle$5 = {
  width: '36px',
  height: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 1px 1px 0',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background .15s ease-out 50ms'
};
var emojiStyle$4 = {
  fontSize: '22px',
  width: '22px',
  height: '22px',
  lineHeight: '26px'
};

var SlackSelectorSection = function SlackSelectorSection(_ref) {
  var _ref$slug = _ref.slug,
      slug = _ref$slug === void 0 ? '' : _ref$slug,
      emojis = _ref.emojis,
      onSelect = _ref.onSelect;
  return React.createElement("div", {
    id: slug
  }, React.createElement("div", {
    style: titleStyle
  }, sectionSlugToName(slug)), React.createElement("div", {
    style: emojisStyle
  }, emojis.map(function (emoji, i) {
    return React.createElement(SlackSelectorSectionEmoji, {
      key: i,
      hoverColor: emojiColors[i % emojiColors.length],
      emoji: emoji,
      onSelect: onSelect
    });
  })));
};
var emojisStyle = {
  display: 'flex',
  flexWrap: 'wrap'
};
var titleStyle = {
  fontWeight: 600,
  WebkitFontSmoothing: 'antialiased',
  fontSize: '16px',
  lineHeight: '1.5rem',
  margin: '0 6px'
};

var SlackSelectorFooter = function SlackSelectorFooter(_ref) {
  var onSelect = _ref.onSelect;
  return React.createElement("div", {
    style: footerStyle
  }, React.createElement("div", {
    style: leftStyle
  }, "Handy Reactions"), React.createElement("div", {
    style: rightStyle
  }, React.createElement(SlackSelectorSection, {
    onSelect: onSelect,
    emojis: ['😀', '👍', '✅', '❤️', '👀']
  })));
};
var footerStyle = {
  padding: '5px 11px',
  borderTop: '1px solid rgba(0,0,0,.15)',
  display: 'flex',
  justifyContent: 'space-between'
};
var leftStyle = {
  fontSize: '16px',
  lineHeight: '1.5',
  margin: '4px 2px',
  fontWeight: 600,
  WebkitFontSmoothing: 'antialiased'
};
var rightStyle = {
  paddingRight: '6px'
};

var SlackSelectorHeaderTab = function SlackSelectorHeaderTab(_ref) {
  var onClick = _ref.onClick,
      id = _ref.id,
      icon = _ref.icon,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active;

  var handleClick = function handleClick() {
    onClick && onClick(id);
  };

  return React.createElement(Hover, {
    hoverStyle: _extends({}, tabStyleHover),
    style: _extends({}, tabStyle, active ? tabStyleActive : {}),
    onClick: handleClick
  }, React.createElement("div", {
    style: iconStyle$1
  }, icon));
};
var tabStyle = {
  color: '#9e9ea6',
  padding: '5px 8px 7px',
  borderRadius: '6px 6px 0 0',
  marginRight: '1px',
  borderBottom: '3px solid transparent',
  cursor: 'pointer'
};
var iconStyle$1 = {
  width: '20px',
  height: '18px',
  fontFamily: 'Slack',
  fontSize: '20px',
  WebkitFontSmoothing: 'antialiased'
};
var tabStyleHover = {
  color: '#555459',
  borderBottom: '3px solid #2ab27b'
};
var tabStyleActive = {
  color: '#9e9ea6',
  borderBottom: '3px solid #2ab27b'
};

var SlackSelectorHeader = function SlackSelectorHeader(_ref) {
  var _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? [] : _ref$tabs;

  var _React$useState = React.useState(''),
      activeString = _React$useState[0],
      setActiveString = _React$useState[1];

  var handleClick = function handleClick(id) {
    var _document;

    (_document = document) == null ? void 0 : _document.getElementById(id).scrollIntoView(false);
    setActiveString(id);
  };

  return React.createElement("div", {
    style: headerStyle
  }, tabs.map(function (tab) {
    return React.createElement(SlackSelectorHeaderTab, {
      icon: tab.icon,
      id: tab.id,
      key: tab.id,
      active: tab.id === activeString,
      onClick: handleClick
    });
  }));
};
var headerStyle = {
  padding: '4px 0 0 7px',
  borderBottom: '1px solid rgba(0,0,0,.15)',
  display: 'flex'
};
SlackSelectorHeader.defaultProps = {
  tabs: [{
    icon: '',
    id: 'mine'
  }, {
    icon: '',
    id: 'people'
  }, {
    icon: '',
    id: 'nature'
  }, {
    icon: '',
    id: 'food-and-drink'
  }, {
    icon: '',
    id: 'activity'
  }, {
    icon: '',
    id: 'travel-and-places'
  }, {
    icon: '',
    id: 'objects'
  }, {
    icon: '',
    id: 'symbols'
  }, {
    icon: '',
    id: 'flags'
  }]
};

var SlackSelectorItems = function SlackSelectorItems(_ref) {
  var scrollHeight = _ref.scrollHeight,
      frequent = _ref.frequent,
      onSelect = _ref.onSelect,
      removeEmojis = _ref.removeEmojis;
  var wrapStyle = React.useMemo(function () {
    return {
      maxHeight: scrollHeight,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: '4px 4px 8px'
    };
  }, [scrollHeight]);
  return React.createElement("div", {
    style: sectionsStyle
  }, React.createElement("div", {
    style: wrapStyle,
    className: "frame"
  }, frequent ? React.createElement(SlackSelectorSection, {
    key: "mine",
    slug: "mine",
    emojis: frequent,
    onSelect: onSelect
  }) : null, Object.keys(emoji).map(function (slug) {
    var group = emoji[slug];
    return React.createElement(SlackSelectorSection, {
      key: slug,
      slug: slug,
      emojis: group.filter(function (e) {
        // https://stackoverflow.com/a/41945742/9931154
        // https://stackoverflow.com/a/34902391/9931154
        return this.indexOf(e) < 0;
      }, removeEmojis),
      onSelect: onSelect
    });
  })));
};
var sectionsStyle = {
  padding: '4px 4px 0',
  background: '#fff'
};

var SlackSelector = function SlackSelector(_ref) {
  var _ref$scrollHeight = _ref.scrollHeight,
      scrollHeight = _ref$scrollHeight === void 0 ? defaultProps$6.scrollHeight : _ref$scrollHeight,
      _ref$frequent = _ref.frequent,
      frequent = _ref$frequent === void 0 ? defaultProps$6.frequent : _ref$frequent,
      _ref$removeEmojis = _ref.removeEmojis,
      removeEmojis = _ref$removeEmojis === void 0 ? defaultProps$6.removeEmojis : _ref$removeEmojis,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps$6.onSelect : _ref$onSelect;
  return React.createElement("div", {
    style: menuStyle
  }, React.createElement(SlackCSS, null), React.createElement(SlackSelectorHeader, null), React.createElement(SlackSelectorItems, {
    scrollHeight: scrollHeight,
    removeEmojis: removeEmojis,
    frequent: frequent,
    onSelect: onSelect
  }), React.createElement(SlackSelectorFooter, {
    onSelect: onSelect
  }));
};
var menuStyle = {
  fontFamily: '"Helvetica Neue",Helvetica,"Segoe UI",Tahoma,Arial,sans-serif',
  width: '358px',
  color: '#555459',
  fontSize: '.95rem',
  background: '#f7f7f7',
  lineHeight: '1rem',
  boxShadow: '0 5px 10px rgba(0,0,0,.12)',
  borderRadius: '6px',
  border: '1px solid rgba(0,0,0,.15)'
};
var defaultProps$6 = {
  scrollHeight: '270px',
  removeEmojis: ['🙂', '🙃', '☺️', '🤑', '🤓', '🤗', '🙄', '🤔', '🙁', '☹️', '🤐', '🤒', '🤕', '🤖'],
  frequent: ['👍', '🐉', '🙌', '🗿', '😊', '🐬', '😹', '👻', '🚀', '🚁', '🏇', '🇨🇦'],
  onSelect: function onSelect(id) {
    console.log(id);
  }
};

var YoutubeCounterButton = function YoutubeCounterButton(_ref) {
  var position = _ref.position,
      number = _ref.number,
      tooltip = _ref.tooltip,
      onClick = _ref.onClick,
      active = _ref.active;
  var iconStyle = React.useMemo(function () {
    return {
      background: "no-repeat url(//s.ytimg.com/yts/imgbin/www-hitchhiker-2x-vflaXbyPz.webp) " + position,
      backgroundSize: '573px 310px',
      width: '20px',
      height: '20px',
      marginRight: '6px'
    };
  }, [position]);
  return React.createElement(Hover, {
    hoverStyle: buttonStyleHover,
    style: _extends({}, buttonStyle, active ? buttonStyleActive : {}),
    onClick: onClick
  }, React.createElement("div", {
    style: iconStyle
  }), parseInt(number, 10).toLocaleString(), React.createElement(HoverStyle, {
    hoverStyle: tooltipStyleHover$2,
    style: tooltipStyle$2
  }, tooltip));
};
var buttonStyle = {
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Roboto,arial,sans-serif',
  fontSize: '11px',
  opacity: '0.5',
  cursor: 'pointer',
  position: 'relative'
};
var tooltipStyle$2 = {
  color: '#fff',
  background: 'rgba(0,0,0,0.8)',
  borderRadius: '3px',
  padding: '5px 8px',
  position: 'absolute',
  bottom: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  marginBottom: '4px',
  whiteSpace: 'nowrap',
  opacity: '0',
  transition: 'opacity 0.1s ease-in-out'
};
var buttonStyleHover = {
  opacity: '0.7'
};
var tooltipStyleHover$2 = {
  opacity: '1'
};
var buttonStyleActive = {
  opacity: '1'
};

var YoutubeCounter = function YoutubeCounter(_ref) {
  var _ref$like = _ref.like,
      like = _ref$like === void 0 ? defaultProps$7.like : _ref$like,
      _ref$dislike = _ref.dislike,
      dislike = _ref$dislike === void 0 ? defaultProps$7.dislike : _ref$dislike,
      _ref$onLikeClick = _ref.onLikeClick,
      onLikeClick = _ref$onLikeClick === void 0 ? defaultProps$7.onLikeClick : _ref$onLikeClick,
      _ref$onDislikeClick = _ref.onDislikeClick,
      onDislikeClick = _ref$onDislikeClick === void 0 ? defaultProps$7.onDislikeClick : _ref$onDislikeClick,
      _ref$didLike = _ref.didLike,
      didLike = _ref$didLike === void 0 ? defaultProps$7.didLike : _ref$didLike,
      _ref$didDislike = _ref.didDislike,
      didDislike = _ref$didDislike === void 0 ? defaultProps$7.didDislike : _ref$didDislike;

  var handleLikeClick = function handleLikeClick() {
    return onLikeClick();
  };

  var handleDislikeClick = function handleDislikeClick() {
    return onDislikeClick();
  };

  return React.createElement("div", {
    style: counterStyle$4
  }, React.createElement(YoutubeCounterButton, {
    number: like,
    position: "-66px -69px",
    tooltip: "I like this",
    onClick: handleLikeClick,
    active: didLike
  }), React.createElement("div", {
    style: spaceStyle
  }), React.createElement(YoutubeCounterButton, {
    number: dislike,
    position: "-390px -148px",
    tooltip: "I dislike this",
    onClick: handleDislikeClick,
    active: didDislike
  }));
};
var defaultProps$7 = {
  like: '3',
  dislike: '2',
  onLikeClick: function onLikeClick() {
    console.log('like');
  },
  onDislikeClick: function onDislikeClick() {
    console.log('dislike');
  },
  didLike: false,
  didDislike: false
};
var counterStyle$4 = {
  display: 'flex'
};
var spaceStyle = {
  width: '12px'
};

var index = 'Reactions';

export default index;
export { FacebookCounter, FacebookCounterReaction, FacebookSelector, FacebookSelectorEmoji, GithubCounter, GithubCounterGroup, GithubSelector, GithubSelectorEmoji, Hover, HoverContext, HoverStyle, PokemonCounter, PokemonSelector, ReactionBarSelector, ReactionBarSelectorEmoji, ReactionCounter, SlackCounter, SlackCounterGroup, SlackSelector, SlackSelectorFooter, SlackSelectorHeader, SlackSelectorHeaderTab, SlackSelectorItems, SlackSelectorSection, SlackSelectorSectionEmoji, YoutubeCounter, YoutubeCounterButton, emoji, emojiColors, groupBy, icons$1 as icons, listOfNames, sectionSlugToName, useHover, withActive };
//# sourceMappingURL=react-reactions.esm.js.map
